import { useState } from "react";
import Countdown from "react-countdown";
import { Button } from "../../components/Button";
import { Section } from "../../components/Section";
import { SectionTitle } from "../../components/SectionTitle";
import { Spacer } from "../../components/Spacer";
import { WriteDownSvg } from "../../components/Svg/Icons/WriteDown";
import { FadeUp } from "../../components/Transitions/FadeUp";

const EVENT_DATE = "2026-11-01T12:00:00+0100";

export const CountDown = () => {
  const event = {
    title: "Boda Natalia y David",
    location: "Sevilla",
    start: "20261101T120000",
    end: "20261102T013000",
  };

  const googleCalendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
    event.title,
  )}&location=${encodeURIComponent(
    event.location,
  )}&dates=${event.start}/${event.end}`;

  const [completed, setCompleted] = useState(false);

  return (
    <Section className="bg-white">
      <FadeUp>
        {/* <div className="w-2/3 max-w-56 m-auto md:max-w-64">
          <img src="/iniciales.png" alt="Iniciales" />
        </div> */}

        <SectionTitle
          title="Cuenta atrás"
          subtitle="Para el día más especial de nuestras vidas"
          className="mb-16"
          eyeBrow
        />

        <div className="mx-auto flex justify-center">
          <Countdown
            date={new Date(EVENT_DATE)}
            intervalDelay={0}
            precision={1}
            renderer={({ days, hours, minutes, seconds, completed }) => {
              if (completed) {
                setCompleted(true);
                return (
                  <div className="text-primary-text text-2xl md:text-4xl lg:text-6xl uppercase font-bold">
                    ¡Llegó el día!
                  </div>
                );
              }

              return (
                <div className="grid grid-cols-4 gap-4 md:gap-25 lg:gap-30 max-w-200">
                  {/* <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-8 lg:gap-10 max-w-4xl"> */}
                  <TimeItem value={days} label="Días" />
                  <TimeItem value={hours} label="Horas" />
                  <TimeItem value={minutes} label="Minutos" />
                  <TimeItem value={seconds} label="Segundos" />
                </div>
              );
            }}
          />
        </div>

        {!completed && (
          <>
            <Spacer />

            <div className="flex justify-center pt-2">
              <div>
                <Button
                  bgColor="secondary-light"
                  textColor="primary-text"
                  borderColor="primary-text"
                  icon={
                    <WriteDownSvg
                      width="35px"
                      color="var(--color-primary-text)"
                    />
                  }
                  className="shadow-md"
                  to={{
                    href: googleCalendarUrl,
                    target: "_blank",
                  }}
                >
                  Guardar la fecha
                </Button>
              </div>
            </div>
          </>
        )}
      </FadeUp>
      <FadeUp>
        <div className="mt-16 w-11/12 max-w-220 m-auto">
          <img src="/motivos2.png" alt="Motivos" className="" />
        </div>
      </FadeUp>
    </Section>
  );
};

const TimeItem = ({ value, label }: { value: number; label: string }) => {
  return (
    <div className=" text-center text-primary-text">
      <div className="pb-2 text-4xl font-semibold md:text-5xl">{value}</div>
      <div className="mt-2 text-base md:text-xl">{label}</div>
    </div>
  );
};
